import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  tipoAmostra = '';
  mostrarResultado = false;
  parametroRacao = false;
  erro = false;
  pesoPeneira19 = 0;
  pesoPeneira8 = 0;
  pesoPeneira4 = 0;
  pesoFundo = 0;
  pesoConjunto = 0;
  pesoSilagem19 = 0;
  pesoSilagem8 = 0;
  pesoSilagem4 = 0;
  pesoSilagemFundo = 0;
  pesoLiquido19 = '0';
  pesoLiquido8 = '0';
  pesoLiquido4 = '0';
  pesoLiquidoFundo = '0';
  resultado19 = '0';
  resultado8 = '0';
  resultado4 = '0';
  resultadoFundo = '0';

  inicio19 = '0';
  fim19 = '0';
  inicio8 = '0';
  fim8 = '0';
  inicio4 = '0';
  fim4 = '0';
  inicioFundo = '0';
  fimFundo = '0';

  selectText(event) {
    event.target.select();
  }

  calcular() {
    if (this.tipoAmostra == '') {
      this.erro = true;
      window.scrollTo(0, 0);
      return;
    }
    
    this.erro = false;
    this.mostrarResultado = true;
    this.parametroRacao = false;

    switch (this.tipoAmostra) {
      case 'milho':
        this.inicio19 = '3';
        this.fim19 = '8';
        
        this.inicio8 = '45';
        this.fim8 = '65';

        this.inicio4 = '20';
        this.fim4 = '30';
        break;

      case 'secado':
        this.inicio19 = '10';
        this.fim19 = '20';
        
        this.inicio8 = '45';
        this.fim8 = '75';

        this.inicio4 = '30';
        this.fim4 = '40';
        break;
    
      case 'racao':
        this.inicio19 = '2';
        this.fim19 = '8';
        
        this.inicio8 = '30';
        this.fim8 = '50';

        this.inicio4 = '10';
        this.fim4 = '20';

        this.parametroRacao = true;
        this.inicioFundo = '30';
        this.fimFundo = '40';
        break;
    }


    // soma o peso do conjunto, sem silagem
    let pesoConjunto = 0;
    let pesoSilagemConjunto = 0;

    pesoConjunto = this.pesoPeneira19 + this.pesoPeneira8 + this.pesoPeneira4 + this.pesoFundo;

    // soma o peso do conjunto, com silagem
    pesoSilagemConjunto = this.pesoSilagem19 + this.pesoSilagem8 + this.pesoSilagem4 + this.pesoSilagemFundo;

    // calcula o peso líquido de cada peneira
    let liquido19 = 0;
    let liquido8 = 0;
    let liquido4 = 0;
    let liquidoFundo = 0;

    liquido19 = this.pesoSilagem19 - this.pesoPeneira19;
    this.pesoLiquido19 = liquido19.toFixed(3) ;

    liquido8 = this.pesoSilagem8 - this.pesoPeneira8;
    this.pesoLiquido8 = liquido8.toFixed(3);

    liquido4 = this.pesoSilagem4 - this.pesoPeneira4;
    this.pesoLiquido4 = liquido4.toFixed(3);

    liquidoFundo = this.pesoSilagemFundo - this.pesoFundo;
    this.pesoLiquidoFundo = liquidoFundo.toFixed(3);

    // calcula o % segundo formula da Penn State
    let resultado19 = 0;
    let resultado8 = 0;
    let resultado4 = 0;
    let resultadoFundo = 0;

    resultado19 = (liquido19 / (pesoSilagemConjunto - pesoConjunto)) * 100;
    this.resultado19 = resultado19.toFixed(2);

    resultado8 = (liquido8 / (pesoSilagemConjunto - pesoConjunto)) * 100;
    this.resultado8 = resultado8.toFixed(2);

    resultado4 = (liquido4 / (pesoSilagemConjunto - pesoConjunto)) * 100;
    this.resultado4 = resultado4.toFixed(2);

    resultadoFundo = (liquidoFundo / (pesoSilagemConjunto - pesoConjunto)) * 100;
    this.resultadoFundo = resultadoFundo.toFixed(2);
  }
}
